export interface PenurunanTingkatRisikoMain {
  id: number
  ulid: string
  tingkat_risiko_inherent: string
  tingkat_risiko_target: string
  tingkat_risiko_existing: string
  percentage: string
  created_at: string
  updated_at: string
}

export interface PenurunanTingkatRisikoDataModel {
  main: {
    data: PenurunanTingkatRisikoMain[];
    total: number;
  };
}

export interface NormalizedPenuruanTingkatRisiko {
  tingkat_risiko_inherent: string
  tingkat_risiko_target: string
  tingkat_risiko_existing: TingkatRisikoExisting[]
}

export interface TingkatRisikoExisting {
  key: string
  percentage: number
}

export enum PenurunanTingkatRisikoActionType {
  GetPenurunanTingkatRisiko = "⌘➝Parameter Setting➝Scoring➝GetPenurunanTingkatRisiko",
}

export type PenurunanTingkatRisikoAction = {
  type: PenurunanTingkatRisikoActionType.GetPenurunanTingkatRisiko;
  data: {
    data: PenurunanTingkatRisikoMain[];
    total: number;
  };
};
